"use client";

import { Moon, Sun } from "lucide-react";

const STORAGE_KEY = "nexo-theme";

export function ThemeToggle() {
  function toggle() {
    const next = document.documentElement.dataset.theme !== "dark";
    document.documentElement.dataset.theme = next ? "dark" : "light";
    localStorage.setItem(STORAGE_KEY, next ? "dark" : "light");
  }

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label="تغییر حالت شب و روز"
      title="تغییر حالت شب و روز"
    >
      <span className="theme-toggle-track" aria-hidden="true">
        <Sun size={16} className="theme-icon-sun" />
        <Moon size={15} className="theme-icon-moon" />
        <span className="theme-toggle-thumb" />
      </span>
    </button>
  );
}
